module.exports = __webpack_public_path__ + "static/media/s_v10_19.5cc5526c.mp3";